<div [formGroup]="parentFormGroup()" class="input-container">
  <mat-form-field appearance="outline" class="input-field">
    <mat-label>{{ "SHARED.CONTACT_SECTION.FIRST_NAME" | translate }}</mat-label>
    <input
      [attr.data-testid]="category() + '-first-name'"
      matInput
      type="text"
      name="firstName"
      formControlName="firstName"
    />
    <mat-error appErrorMessages="firstName" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="input-field">
    <mat-label>{{ "SHARED.CONTACT_SECTION.LAST_NAME" | translate }}</mat-label>
    <input
      [attr.data-testid]="category() + '-last-name'"
      matInput
      type="text"
      name="lastName"
      formControlName="lastName"
    />
    <mat-error appErrorMessages="lastName" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="input-field">
    <mat-label>{{ "SHARED.CONTACT_SECTION.EMAIL" | translate }}</mat-label>
    <input
      [attr.data-testid]="category() + '-email'"
      matInput
      type="text"
      name="email"
      formControlName="email"
    />
    <mat-error appErrorMessages="email" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="input-field">
    <mat-label>{{ "SHARED.CONTACT_SECTION.PHONE" | translate }}</mat-label>
    <input
      [attr.data-testid]="category() + '-phone'"
      matInput
      type="text"
      name="phone"
      formControlName="phone"
    />
    <mat-error appErrorMessages="phone" />
  </mat-form-field>
</div>
